<template>
  <L1 class="restaurantTablesv2">
    <template slot="slot_title">
      <Select :defaultValue="store" @input="store=$event" :width="'665px'">
        <option v-for="rest in restaurants" :key="rest" :value="rest">{{rest}}</option>
      </Select>
    </template>
    <LF :style="{padding: 0}">
    <template slot="filter">
      <template v-if="areas.length>0">
        <draggable v-if="sortArea" :group="{name: 'areas', put: false, pull: false}" v-model="areas" :style="{display: 'flex', gap: '15px'}">
          <input v-for="(area, a) in areas"
          type="radio"
          :key="`area-${a}`"
          v-model="page" :value="area.name">
        </draggable>
        <div v-else :style="{display: 'flex', gap: '15px'}">
          <input v-for="(area, a) in areas"
          type="radio"
          :key="`area-${a}`"
          v-model="page" :value="area.name">
        </div>
        <input type="checkbox" v-model="sortArea" title="排序">
      </template>
      <button :style="{marginLeft: 'auto'}" class="addTeam" @click="newarea=null;addarea=true"></button>
    </template>
    <div class="container-areatable">
      <div>
        <div>
          <div class="smark">請選擇桌子類型後<br>並在右側空白處標示/移動</div>
          <div class="sense"
          @choose="clone"
          :group="{name: 'tables', pull: 'clone', put: false}">
            <div class="big_round" @click="addTable('big_round')">
            </div>
            <div class="small_round" @click="addTable('small_round')">
            </div>
            <div class="big_rect rotate" @click="addTable('big_rect rotate')">
            </div>
            <div class="big_rect" @click="addTable('big_rect')">
            </div>
            <div class="small_rect" @click="addTable('small_rect')">
            </div>
          </div>
          <div class="areasize" v-if="area">
            <div>場域大小</div>
            <div>
              <span>W<input type="text" v-model.number="area.width"></span>
              <span>xH<input type="text" v-model.number="area.height"></span>
            </div>
          </div>
          <draggable class="deletebox"
          :group="{name: 'tables', pull: false, put: true}">
          </draggable>
        </div>
      </div>
      <div class="areasbox">
        <div v-if="area">
          <div v-if="editName===false">{{area.name}}<button class="editbtn" @click="nameEdit=area.name;editName=true"  title="編輯區域名稱"/></div>
          <div v-else>
            <input type="text" v-model.trim="nameEdit" class="areanamebox">
            <div class="btns">
              <button class="cancel" @click="editName=false">取消</button>
              <button class="confirm" @click="saveName">確認</button>
            </div>
          </div>
        <button class="saveBtn" :style="{width: '100px', background: 'var(--color-border)', marginLeft: 'auto'}" @click="deleteArea=true">刪除區域</button>
        <button class="saveBtn" :style="{width: '100px'}" @click="saveArea">儲存區域</button>
        <button class="infoBtn" @click="helper=true"></button>
        </div>
        <div class="fns">
          <button @click="move=!move" :title="move?'已解鎖':'鎖定中'"><span v-if="move">🔒</span><span v-else>🔓</span></button>
          <template v-if="move">
          <button @click="selectTables=tables.map((e, i) => i)">全選</button>
          <button @click="selectTables=[]">取消全選</button>
          <button @click="alignUp">向上對齊</button>
          <button @click="alignDown">向下對齊</button>
          <button @click="alignLeft">向左對齊</button>
          <button @click="alignRight">向右對齊</button>
          </template>
        </div>
        <draggable class="areas" v-if="area&&!move" v-model="tables"
          group="tables"
          :id="area.name"
          @remove="remove($event)"
          :style="{minWidth: `${area.width}px`, minHeight: `${area.height}px`}">
          <div v-for="(table, t) in tables" :key="`table-${t}`"
          :class="table.style"
          class="table"
          :id="t"
          :style="{
            top: `${table.coordinates[1]}px`,
            left: `${table.coordinates[0]}px`
          }"
          >
          <div>桌號</div>
          <div><input type="text" v-model="tables[t].name"></div>
          <div :style="{color: '#FFFFFF'}" v-if="tables[t].n1">今日 {{tables[t].n1}}</div>
          <div :style="{color: '#FFFFFF'}" v-if="tables[t].n2">預約 {{tables[t].n2}}</div>
          <!-- <button>儲存</button> -->
          </div>
        </draggable>
        <div class="areas" v-else-if="area&&move"
        :id="area.name"
        :style="{minWidth: `${area.width}px`, minHeight: `${area.height}px`, cursor: tableGrab ? 'grabbing!important' : 'grab!important'}">
          <div v-for="(table, t) in tables" :key="`table-${t}`"
          :class="[table.style, selectTables.includes(t)?'selected':'']"
          class="table"
          :id="t"
          :style="{
            top: `${table.coordinates[1]}px`,
            left: `${table.coordinates[0]}px`
          }"
          @click.exact="selectTables=[]"
          @click.ctrl="select(t)"
          @dragstart.ctrl="copy($event, t)"
          @dragstart.shift="dragstart2($event, t)"
          @dragstart.exact="dragstart($event, t)"
          @drag.shift="drag2($event, t)"
          @drag.exact="drag($event, t)"
          @dragend.exact="dragend($event, t)"
          draggable
          >
          <div>桌號</div>
          <div><input type="text" v-model="tables[t].name"></div>
          <!-- <button>儲存</button> -->
          </div>
        </div>
      </div>
      <div class="helper" v-if="helper">
        <div>
          <h2>餐桌設定</h2>
          <p>
          1. 選取右側桌子類型將桌子加入地圖<br>
          2. 請修改桌號，桌號請設定為不重複編號。<br>(不同區域也請不要重複)<br>
          3. 按下"🔒"按鈕解除鎖定後，<br>
          區域中的桌面可使用滑鼠移動。<br>
          4. 移動完成後請按下"儲存區域"儲存。<br>
          5. 刪除桌子請鎖定桌面(按鈕變為"🔒");<br>拖曳桌子到右下刪除桌子區域並按下"儲存區域"儲存。<br>
          <br>tip:<br>
          <span :style="{fontSize: 'smaller'}">
          1. 按住Ctrl並點選桌子可選取(可選取多個)。<br>
          2. 選取後，按住Ctrl並拖曳可複製桌子。<br>
          3. 選取後，按住Shift並拖曳可同時移動多個桌子。<br>
          4. 取消選取請點選任意桌子即可。
          </span>
          </p>
        </div>
        <button class="closebtn" @click="helper=false"></button>
      </div>
    </div>
    <div class="customDate" v-if="daterange==='自訂時間'&&rangeSelect===true">
      <vue-ctk-date-time-picker :range="false" v-model="date"
      :color="'var(--color-pri)'"
      :no-label="true"
      :input-size="'sm'"
      :label="'選取時間範圍'"
      :format="'YYYY-MM-DD'"
      :formatted="'YYYY-MM-DD'"
      />
      <button @click="rangeSelect=false"></button>
    </div>
    <dialogbox v-if="addarea" :show="true" @close="addarea=false" label="新增區域">
      <div class="addarea123" :style="{padding: '20px', gap: '10px', display:'flex', flexDirection: 'column', alignItems: 'center'}">
        <div>區域名稱</div>
        <input type="text" v-model="newarea">
        <div class="btns" :style="{paddingTop: '20px'}">
          <button class="cancel" @click="addarea=false">取消</button>
          <button class="confirm" @click="adda">確認</button>
        </div>
      </div>
    </dialogbox>
    <dialogbox v-if="deleteArea" :show="true" @close="deleteArea=false" label="刪除區域">
      <div class="addarea123" :style="{padding: '20px', gap: '10px', display:'flex', flexDirection: 'column', alignItems: 'center'}">
        <div>確認要刪除?</div>
        <div class="areaname">{{area.name}}</div>
        <div class="btns" :style="{paddingTop: '20px'}">
          <button class="cancel" @click="deleteArea=false">取消</button>
          <button class="confirm" @click="deleteA">確認</button>
        </div>
      </div>
    </dialogbox>
  </LF>
  </L1>
</template>

<script>
import { mapState } from 'vuex'
import L1 from '../../components/layout/L1.vue'
import LF from '../../components/layout/LaTable.vue'
import draggable from 'vuedraggable'
import Select from '../../components/select.vue'
import dialogbox from '../../components/dialognoPadding2.vue'
import { deleteapi, getapi, postapi, putapi } from '../../store/fetch'
export default {
  name: 'tablesSet',
  components: {
    draggable,
    dialogbox,
    L1,
    LF,
    Select
  },
  data () {
    return {
      store: null,
      helper: true,
      sortArea: false,
      editName: false,
      nameEdit: null,
      deleteArea: false,
      newarea: null,
      addarea: false,
      move: false,
      daterange: '今日預約',
      date: this.moment().format('YYYY-MM-DD'),
      page: null,
      rows: [],
      item: null,
      areas: [],
      tables: [],
      now: this.moment().format('HH:mm:ss'),
      itemSelect: null,
      nowtime: this.moment(),
      startPointerInfo: null,
      grabbing: false,
      tableGrab: null,
      selectTables: []
    }
  },
  watch: {
    async sortArea () {
      if (!this.sortArea) {
        await postapi('tables/sort', {
          areas: this.areas.map((e, i) => {
            return {
              id: e._id,
              num: String(i)
            }
          })
        })
      }
    },
    page () {
      this.resync()
    },
    date () {
      this.resync()
    },
    store: {
      async handler () {
        const areas = await getapi(`tables/store/${this.store}`)
        this.page = areas[0]?.name || null
        this.tables = areas[0] ? JSON.parse(JSON.stringify(areas[0].tables)) : []
        this.areas = areas
      },
      immediate: true
    },
    daterange () {
      switch (this.daterange) {
        case '今日預約':
          this.date = this.moment().format('YYYY-MM-DD')
          break
        case '明日預約':
          this.date = this.moment().add(1, 'day').format('YYYY-MM-DD')
          break
      }
    }
  },
  computed: {
    restaurants () {
      return this.restaurantsInfos.filter(e => e.storeType === 'restaurant').map(e => e.name)
    },
    area () {
      if (this.page && this.areas.length > 0) {
        return this.areas.find(e => e.name === this.page)
      } else {
        return null
      }
    },
    ...mapState({
      restaurantsInfos: 'restaurantsInfos',
      defaultStore: 'defaultStore'
    })
  },
  async mounted () {
    this.store = this.defaultStore || this.restaurants[0]
    setInterval(() => {
      this.nowtime = this.moment()
    }, 5 * 60 * 1000)
    // // console.log('area', this.area)
  },
  methods: {
    alignUp () {
      const ylist = this.selectTables.map(e => this.tables[e].coordinates[1])
      const top = Math.min(...ylist)
      // // console.log(top)
      this.selectTables.forEach(e => {
        this.tables[e].coordinates = [
          this.tables[e].coordinates[0],
          top
        ]
      })
    },
    alignDown () {
      const ylist = this.selectTables.map(e => {
        const height = this.getHeight(this.tables[e].style)
        return this.tables[e].coordinates[1] + height
      })
      const bottom = Math.max(...ylist)
      // // console.log(bottom)
      this.selectTables.forEach(e => {
        const height = this.getHeight(this.tables[e].style)
        this.tables[e].coordinates = [
          this.tables[e].coordinates[0],
          bottom - height
        ]
      })
    },
    alignLeft () {
      const xlist = this.selectTables.map(e => this.tables[e].coordinates[0])
      const left = Math.min(...xlist)
      // console.log(left)
      this.selectTables.forEach(e => {
        this.tables[e].coordinates = [
          left,
          this.tables[e].coordinates[1]
        ]
      })
    },
    alignRight () {
      const xlist = this.selectTables.map(e => {
        const width = this.getWdith(this.tables[e].style)
        // console.log(width)
        return this.tables[e].coordinates[0] + width
      })
      const right = Math.max(...xlist)
      // console.log('right', right)
      this.selectTables.forEach(e => {
        const width = this.getWdith(this.tables[e].style)
        this.tables[e].coordinates = [
          right - width,
          this.tables[e].coordinates[1]
        ]
      })
    },
    getWdith (style) {
      // console.log('style', style)
      switch (style) {
        case 'big_round':
          return 226
        case 'small_round':
          return 135
        case 'big_rect':
          return 120
        case 'big_rect rotate':
          return 160
        case 'small_rect':
          return 120
      }
    },
    getHeight (style) {
      // console.log('style', style)
      switch (style) {
        case 'big_round':
          return 226
        case 'small_round':
          return 135
        case 'big_rect':
          return 160
        case 'big_rect rotate':
          return 120
        case 'small_rect':
          return 120
      }
    },
    async saveName () {
      const r = await postapi(`tables/a/${this.area._id}`, { name: this.nameEdit })
      if (r) {
        const index = this.areas.map(e => e._id).indexOf(this.area._id)
        this.areas[index] = r
        // console.log('name', r.name)
        setTimeout(() => {
          this.page = r.name
          this.editName = false
        }, 200)
      }
    },
    async deleteA () {
      const r = await deleteapi(`tables/a/${this.area._id}`)
      if (r) {
        const index = this.areas.map(e => e._id).indexOf(this.area._id)
        this.areas.splice(index, 1)
        this.page = this.areas[0].name
        this.deleteArea = false
      }
    },
    copy () {
      const tables = this.selectTables.map(e => {
        const data = JSON.parse(JSON.stringify(this.tables[e]))
        delete data._id
        // console.log(data)
        data.coordinates[0] = data.coordinates[0] + 50
        data.coordinates[1] = data.coordinates[1] + 50
        data.name = data.name + ' copy'
        return data
      })
      this.tables.push(...tables)
    },
    select (t) {
      // console.log('select', t)
      const select = this.selectTables
      if (select.includes(t)) {
        this.selectTables = select.filter(e => e !== t)
      } else {
        select.push(t)
        this.selectTables = Array.from(new Set(select))
      }
    },
    async saveArea () {
      // console.log({
      //   tables: this.tables,
      //   width: this.area.width,
      //   height: this.area.height
      // })
      this.$store.commit('setFetching', true)
      const newarea = await putapi(`tables/a/${this.area._id}/tables`, {
        tables: this.tables,
        width: this.area.width,
        height: this.area.height
      })
      // console.log(newarea)
      const index = this.areas.map(e => e._id).indexOf(newarea._id)
      this.areas.splice(index, 1, newarea)
      this.tables = newarea.tables
      this.page = newarea.name
      this.$store.commit('setFetching', false)
    },
    async adda () {
      this.$store.commit('setFetching', true)
      const newarea = await putapi('tables/a', { name: this.newarea, store: this.store })
      this.areas.push(newarea)
      this.area = newarea
      this.addarea = false
      this.$store.commit('setFetching', false)
    },
    dragstart (e, t) {
      // console.log('dragstart', e)
      this.grabbing = true
      this.tableGrab = t
      this.setPointerState([e])
    },
    dragstart2 (e, t) {
      // console.log('dragstart 2', e)
      this.grabbing = true
      this.tableGrab = t
      // console.log('dragstart 2', t)
      this.setPointerState([e])
    },
    dragend (e) {
      // console.log('dragend', e)
      this.tableGrab = null
    },
    drag (e) {
      if (!this.startPointerInfo || this.disablePan) {
        return
      }
      this.startMoving = true
      e.preventDefault()
      this.onDrag(e)
    },
    drag2 (e) {
      if (!this.startPointerInfo || this.disablePan) {
        return
      }
      this.startMoving = true
      e.preventDefault()
      this.onDrag2(e)
    },
    onDrag (pointer) {
      const { coordinates, pointers } = this.startPointerInfo
      const startPointer = pointers[0]
      const dragX = pointer.clientX - startPointer.clientX
      const dragY = pointer.clientY - startPointer.clientY
      // console.log(dragX, dragY, coordinates[0] + dragX, coordinates[1] + dragY, coordinates)
      if ((coordinates[0] + dragX) > 0 && (coordinates[1] + dragY) > 0) {
        this.tables[this.tableGrab].coordinates = [
          coordinates[0] + dragX,
          coordinates[1] + dragY
        ]
      }
    },
    onDrag2 (pointer) {
      const { coordinates, pointers } = this.startPointerInfo
      const startPointer = pointers[0]
      const dragX = pointer.clientX - startPointer.clientX
      const dragY = pointer.clientY - startPointer.clientY
      if ((coordinates[0] + dragX) > 0 && (coordinates[1] + dragY) > 0) {
        const deltaX = this.tables[this.tableGrab].coordinates[0] - (coordinates[0] + dragX)
        const deltaY = this.tables[this.tableGrab].coordinates[1] - (coordinates[1] + dragY)
        // console.log('drag2', dragX, dragY, deltaX, deltaY, coordinates[0] + dragX, coordinates[1] + dragY, coordinates)
        this.selectTables.forEach(e => {
          this.tables[e].coordinates = [
            this.tables[e].coordinates[0] - deltaX,
            this.tables[e].coordinates[1] - deltaY
          ]
        })
      }
    },
    setPointerState (pointers) {
      if (!pointers || pointers.length === 0) {
        this.startPointerInfo = undefined
        return
      }
      this.startPointerInfo = {
        pointers,
        coordinates: JSON.parse(JSON.stringify(this.tables[this.tableGrab].coordinates))
      }
    },
    addTable (type) {
      // console.log(this.area)
      switch (type) {
        case 'big_round':
          this.tables.push({
            coordinates: [113, 113],
            style: 'big_round',
            type: 'Point',
            available: 12,
            name: 'TBD',
            parentMap: this.area._id
          })
          break
        case 'small_round':
          this.tables.push({
            coordinates: [67.5, 67.5],
            style: 'small_round',
            type: 'Point',
            available: 10,
            name: 'TBD',
            parentMap: this.area._id
          })
          break
        case 'big_rect':
          this.tables.push({
            coordinates: [60, 80],
            style: 'big_rect',
            type: 'Point',
            available: 6,
            name: 'TBD',
            parentMap: this.area._id
          })
          break
        case 'big_rect rotate':
          this.tables.push({
            coordinates: [80, 60],
            style: 'big_rect rotate',
            type: 'Point',
            available: 6,
            name: 'TBD',
            parentMap: this.area._id
          })
          break
        case 'small_rect':
          this.tables.push({
            coordinates: [60, 60],
            style: 'small_rect',
            type: 'Point',
            available: 4,
            name: 'TBD',
            parentMap: this.area._id
          })
          break
      }
    },
    async resync () {
      const areas = this.areas
      this.tables = JSON.parse(JSON.stringify(areas.find(e => e.name === this.page).tables))
      // console.log('area', this.area)
    },
    clone (e) {
      this.itemSelect = null
      // console.log('clone', /now/.test(e.item.className), e.item.className, e)
    },
    // chooose (e) {
    //   this.itemSelect = this.tables[e.oldIndex]
    //   // console.log('chooose', /now/.test(e.item.className), e.item.className, e.item)
    // },
    async remove (e, i) {
      // console.log('remove', [e.to.id, e.from.id, e.oldIndex, e.newIndex, this.itemSelect])
      // // console.log(this.tables.splice(e.oldIndex, 1), this.tables)
    },
    async add (e, i) {
      // console.log('add', this.itemSelect)
      if (this.itemSelect) {
        if (this.itemSelect.orderer === '現場排位') {
          await postapi(`/tables/table/${this.rows[i]._id}`, {
            status: {
              visitTime: this.moment().format('HH:mm'),
              orderer: '現場排位'
            }
          })
          this.resync()
        } else {
          const old = await getapi(`restaurant/${this.itemSelect._id}`)
          const tables = old.tables.filter(t => t).filter(t => t !== '')
          const index = tables.indexOf(e.from.id)
          tables.splice(index, 1, e.to.id)
          await postapi(`restaurant/${this.itemSelect._id}`, { tables })
          this.resync()
        }
      } else {
        if (/now/.test(e.item.className)) {
          // console.log('set unavailable', this.rows[i]._id)
          await postapi(`/tables/table/${this.rows[i]._id}`, {
            status: {
              visitTime: this.moment().format('HH:mm'),
              orderer: '現場排位'
            }
          })
        } else {
          // console.log('set unavailable', this.rows[i]._id)
          await postapi(`/tables/table/${this.rows[i]._id}`, {
            status: {
              visitTime: this.moment().format('HH:mm'),
              orderer: '暫停使用'
            }
          })
        }
        this.resync()
      }
      // console.log('add2', [e.to.id, e.from.id, e.oldIndex, e.newIndex])
    },
    async getTables () {
      this.areas = await getapi('tables')
    }
  }
}
</script>

<style lang="scss">
.restaurantTablesv2 {
  * {
    box-sizing: border-box;
  }
  .filter {
    border-bottom: 1px solid #CACACA;
    padding-right: 20px;
  }
}
.addarea123 {
  div {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 23px;
    letter-spacing: 0.1em;
    color: var(--color-letter);
  }
  input {
    width: 400px;
    height: 40px;
    background: #FFFFFF;
    border: 1px solid var(--color-border);
    box-sizing: border-box;
    border-radius: 3px;
    text-align: center;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 23px;
    letter-spacing: 0.1em;
    color: var(--color-letter);
  }
}
.customDate {
  .field-input {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 18px!important;
    line-height: 36px;
    letter-spacing: 0.1em;
    color: var(--color-letter);
  }
}
</style>
<style lang="scss" scoped>
.fns {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 2px;
  padding-block: 10px;
}
.fns > button {
  width: fit-content;
  padding-inline: 6px;
  padding-block: 3px;
  border: 1px solid var(--color-border);
  border-radius: 3px;
  background-color: transparent;
  color: var(--color-checked);
  letter-spacing: .1em;
  font-size: 14px;
}
.infoBtn {
  width: 34px;
  height: 34px;
  mask-image: url(/info.svg);
  border: none;
  mask-position: center;
  mask-repeat: no-repeat;
  mask-size: contain;
  background-color: var(--color-border);
}
.helper {
  position: absolute;
  right: 0px;
  top: 0;
  bottom: 0;
  width: fit-content;
  background-color: #959595AA;
  padding-inline: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-block: 50px;
  &>div {
    background-color: #959595;
    padding: 20px;
    text-align: start;
    color: #FFFFFF;
    border-radius: 5px;
    p {
      line-height: 40px;
      font-size: 18px;
    }
  }
  .closebtn {
    position: absolute;
    right: 5px;
    top: 5px;
    background-image: url(/close.svg);
    width: 40px;
    height: 40px;
    background-color: transparent;
    background-position: center;
    background-repeat: no-repeat;
    border: none;
  }
}
input[type=checkbox] {
  appearance: none;
  width: 35px;
  height: 35px;
  background-color: var(--color-checked);
  border-radius: 50%;
  background-image: url(/sort.svg);
  transform: rotate(90deg);
  background-repeat: no-repeat;
  background-position: center;
  &:checked {
    background-color: var(--color-confirm);
    background-image: url(/save.svg);
    transform: rotate(0deg);
  }
}
.editbtn {
  width: 35px;
  height: 35px;
  background-color: var(--color-checked);
  background-image: url(/pen.svg);
  border: none;
  border-radius: 50%;
  background-position: center;
  background-repeat: no-repeat;
  margin-left: 20px;
}
.areaname {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 35px;
  line-height: 41px;
  letter-spacing: 0.1em;
  color: var(--color-checked);
}
.btns{
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 28px;
  button {
    &:disabled {
      filter: contrast(.5);
    }
    border: none;
    width: 100px;
    height: 35px;
    border-radius: 20px;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    &.confirm {
      background: #E37878;
    }
    &.cancel {
      background: #B8B8B8;
    }
  }
}
.addTeam {
  width: 150px;
  box-sizing: border-box;
  height: 50px;
  background: var(--color-checked);
  border-radius: 50px;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  letter-spacing: 0.1em;
  color: #FFFFFF;
  border:none;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  gap: 3px;
  &:hover {
    filter: contrast(.5);
  }
  &::before {
  content: '';
  display: inline-block;
  background-repeat: no-repeat;
  background-position: center;
  }
}
.addTeam::before {
  width: 29px;
  height: 29px;
  background-image: url(/plus.svg);
}
.addTeam::after {
  content: '新增區域';
}
.table {
  background-color: var(--color-checked);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  &>div:nth-child(1) {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
  }
  &>div:nth-child(2)>input {
    width: 101px;
    height: 30px;
    text-align: center;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: var(--color-letter);
    border-radius: 3px;
    border: none;
  }
  button {
    width: 60px;
    height: 25px;
    background: #E37878;
    border-radius: 30px;
    border: 1px solid #FFFFFF;
    font-family: 'Noto Sans TC';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    box-sizing: border-box;
    padding-bottom: 4px;
  }
}
.saveBtn {
  border: none;
  width: 85px;
  height: 35px;
  border-radius: 20px;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 35px;
  letter-spacing: 0.1em;
  color: #FFFFFF;
  background: #E37878;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    filter: contrast(.5);
  }
}
.customDate {
  display: flex;
  position: fixed;
  top: 74px;
  right: 50px;
  width: 400px;
  height: 80px;
  box-shadow: 4px 0px 15px rgba(0, 0, 0, 0.25);
  margin-top: 10px;
  background-color: #FFFFFF;
  border-radius: 5px;
  z-index: 1;
  padding: 20px;
  box-sizing: border-box;
  button {
    height: 36px;
    width: 36px;
    border: none;
    &::before {
      content: '⤫';
      font-size: 24px;
    }
  }
}
.deletebox {
  &::before {
    width: 35px;
    height: 38.8px;
    content: '';
    display: inline-block;
    background-image: url(/delete.svg);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
  &::after {
    content: '刪除桌子';
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    text-align: center;
    letter-spacing: 0.1em;
    color: var(--color-confirm);
  }
  background: rgba(227, 120, 120, 0.2);
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100px;
  background-size: 60px;
  background-position: center;
  background-repeat: no-repeat;
  margin-top: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6.2px;
  &>div {
    display: none;
  }
}
.areasbox {
  flex-direction: column;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  height: calc(100vh - 161px);
  overflow-y: auto;
  padding: 20px;
  box-sizing: border-box;
  input[type=text].areanamebox {
    width: 345px;
    height: 40px;
    margin-right: 20px;
    border-radius: 3px;
    border: 1px solid var(--color-border);
    padding-inline: 14px;
    box-sizing: border-box;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 23px;
    letter-spacing: 0.1em;
    color: var(--color-checked);
  }
  &>div:nth-child(1) {
    height: 35px;
    display: flex;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 28px;
    letter-spacing: 0.1em;
    color: var(--color-checked);
    padding-bottom: 15px;
    align-items: center;
    justify-content: flex-start;
    gap: 20px;
    width: -webkit-fill-available;
    &>div:nth-child(1) {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
  }
}
.areas {
  background-color: var(--color-infobox);
  position: relative;
  &>div {
    position: absolute;
    // transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    overflow: hidden;
    &.selected {
      opacity: .5;
    }
    &.big_round {
      border-radius: 113px;
      width: 226px;
      height: 226px;
      box-sizing: border-box;
      position: absolute;
    }
    &.small_round {
      border-radius: 67.5px;
      width: 135px;
      height: 135px;
      box-sizing: border-box;
      position: absolute;
    }
    &.small_rect {
      border-radius: 5px;
      width: 120px;
      height: 120px;
      box-sizing: border-box;
      position: absolute;
    }
    &.big_rect {
      border-radius: 5px;
      width: 120px;
      height: 160px;
      box-sizing: border-box;
      position: absolute;
    }
    &.big_rect.rotate {
      border-radius: 5px;
      height: 120px;
      width: 160px;
      box-sizing: border-box;
      position: absolute;
    }
  }
}
.areasize {
  margin-top: 60px;
  display: flex;
  flex-direction: column;
  text-align: start;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 23px;
  color: var(--color-checked);
  gap: 8px;
  &>:nth-child(2) {
    display: flex;
    align-items: center;
    justify-content: center;
    &>span>input {
      text-align: center;
      margin-inline: 4px;
      border-radius: 3px;
      border: 1px solid var(--color-border);
      width: 60px;
      height: 45px;
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 21px;
      letter-spacing: 0.1em;
      color: var(--color-checked);
    }
  }
}
.sense > div {
  width: 180px;
  height: 50px;
  border-radius: 3px;
  background-color: var(--color-checked);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  &::after{
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 23px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
  }
  &.big_round::after {
    content: '大圓桌';
  }
  &.big_rect.rotate::after {
    content: '4人桌(橫向)';
  }
  &.big_rect::after {
    content: '4人桌(直向)';
  }
  &.small_round::after {
    content: '小圓桌';
  }
  &.small_rect::after {
    content: '2人桌';
  }
}
.sense {
  display: flex;
  flex-direction: column;

  gap: 20px;
}
.container-areatable {
  position: relative;
  display: grid;
  grid-template-columns: 220px 1fr;
  height: calc(100vh - 161px);
  overflow-y: hidden;
  &>:nth-child(1) {
    position: relative;
    border-right: 1px solid var(--color-border);
    padding-inline: 13px;
    padding-top: 20px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: flex-start;
    overflow-y: auto;
    &>div {
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: flex-start;
      gap: 8px;
      height: 100%;
    }
    .smark {
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
      letter-spacing: 0.1em;
      color: #959595;
    }
  }
}
.restaurantSet {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 89px 1fr;
  height: 100%;
}
.title > div {
  display: flex;
  gap: 5px;
}
.restaurantTablesv2 input[type=radio] {
  min-width: 145px;
  width: fit-content;
  padding-inline: 6px;
  height: 40px;
  appearance: none;
  background-color: var(--color-border);
  color: #FFFFFF;
  border-radius: 3px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  letter-spacing: 0.1em;
  display: flex;
  align-items: center;
  justify-content: center;
  &::before {
    content: attr(value);  }

  &:checked {
    background-color: var(--color-checked);
  }

}
</style>
